class S3Manager {
    static async getToken(isProvider = false) {
        return isProvider ? localStorage.getItem('providerToken') : localStorage.getItem('adminToken');
    }

    static async uploadImage(key: string, file: any, isProvider = false, contentType = 'image/jpeg') {
        var token = isProvider ? localStorage.getItem('providerToken') : localStorage.getItem('adminToken');
        if (!token || token === 'undefined') {
            return Promise.reject(new Error('No auth token'));
        }
        const path = isProvider ? 'provider/upload-url' : 'mongol/upload-url';
        const res = await fetch(process.env.REACT_APP_API_URL + path, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ key, contentType }),
        });
        if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            return Promise.reject(err);
        }
        const resJson: any = await res.json();
        const ct = contentType === 'image/webp' ? 'image/webp' : 'image/jpeg';
        const imgBlob = file instanceof Blob ? file : new Blob([file], { type: ct });
        const putRes = await fetch(resJson.uploadUrl, {
            method: 'PUT',
            headers: {
                'Content-Type': ct,
                'x-amz-acl': 'public-read',
            },
            body: imgBlob,
        });
        if (!putRes.ok) {
            const text = await putRes.text().catch(() => '');
            return Promise.reject(new Error(`S3 upload failed: ${putRes.status} ${text}`));
        }
    }

    static deleteImage(photoKey: string, isProvider = false) {
        var token = isProvider ? localStorage.getItem('providerToken') : localStorage.getItem('adminToken');
        if (token && token !== 'undefined') {
            const path = isProvider ? 'provider/delete-bucket-item' : 'mongol/delete-bucket-item';
            fetch(process.env.REACT_APP_API_URL + path, {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': token,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    key: photoKey
                })
            })
            .then((res: any) => {
                console.log("delete bucket item response", res)
            })
            .catch(err => {
                console.error(err)
            })
        }
    }
}

export default S3Manager;